import React, { PropsWithChildren } from 'react';

import { useNewsRibbon } from './NewsRibbon';

export type Props = { hash: string; type: 'global' | 'local'; useGlobal?: boolean };

export const NewsRibbonWrapper = ({
  hash,
  children,
  type,
  useGlobal = false,
}: PropsWithChildren<Props>) => {
  const { visible } = useNewsRibbon({
    hash,
    type,
    useGlobal,
  });

  return visible ? <>{children}</> : null;
};
